import {
  recordsApi2,
  analyticsApi2,
  branchesApi2,
  usersApi2,
  clientServicesApi2,
} from '@app/api';
import { accessRightsApi } from '@app/api/AccessRights';
import { actionsHistoryApi } from '@app/api/ActionsHistory';
import { aiBusinessAnalyticsApi } from '@app/api/AiBusinessAnalytics';
import { aiOperatorConfigApi } from '@app/api/AiOperatorConfig';
import { aiPromptsApi } from '@app/api/AiPrompts';
import { aiServicesApi } from '@app/api/AiServices';
import { authenticationApi } from '@app/api/Authentication';
import { billsApi } from '@app/api/Bills';
import { captchaApi } from '@app/api/Captcha';
import { certificatesApi } from '@app/api/Certificates';
import { chainsApi } from '@app/api/Chains';
import { clientApi2 } from '@app/api/Client';
import { clientFieldsApi } from '@app/api/ClientFields';
import { clientFilesApi2 } from '@app/api/ClientFiles';
import { clientPaymentsApi } from '@app/api/ClientPayments';
import { clientRemindersApi } from '@app/api/ClientReminders';
import { clientsApi3 } from '@app/api/Clients';
import { clientsMergeApi } from '@app/api/ClientsMerge';
import { crmTasksApi as crmTasksApi2 } from '@app/api/CrmTasks';
import { dadataApi } from '@app/api/DaData';
import { debugApi } from '@app/api/Debug';
import { dictionariesApi } from '@app/api/Dictionaries';
import { employeesApi2 } from '@app/api/Employees';
import { employeeSalaryApi } from '@app/api/EmployeeSalary';
import { errorReportsApi } from '@app/api/ErrorReports';
import { expenseArticlesApi } from '@app/api/ExpenseArticles';
import { externalLoyaltyApi } from '@app/api/ExternalLoyalty';
import { integrationAuthApi } from '@app/api/IntegrationAuth';
import { leadsApi3 } from '@app/api/Leads';
import { legalEntitiesApi } from '@app/api/LegalEntities';
import { loggerApi } from '@app/api/Logger';
import { loyaltyApi } from '@app/api/Loyalty';
import { medicalDocumentsApi } from '@app/api/MedicalDocuments';
import { messageTemplatesApi } from '@app/api/MessageTemplates';
import { migrationApi } from '@app/api/Migration';
import { moneyExpensesApi } from '@app/api/MoneyExpenses';
import { neuralNetworkLogsApi } from '@app/api/NeuralNetworkLogs';
import { notificationsApi2 } from '@app/api/Notifications';
import { paymentAccountsApi } from '@app/api/PaymentAccounts';
import { positionsApi2 } from '@app/api/Positions';
import { productsApi } from '@app/api/Products';
import { recommendChatApi } from '@app/api/RecommendChat';
import { robotAttachmentsApi } from '@app/api/RobotAttachments';
import { robotsApi } from '@app/api/Robots';
import { salePlansApi } from '@app/api/SalePlans';
import { salesFunnelsApi2 } from '@app/api/SalesFunnels';
import { salesFunnelStageLeadApi2 } from '@app/api/SalesFunnelStageLead';
import { sendoutsApi2 } from '@app/api/Sendouts';
import { settingsApi } from '@app/api/Settings';
import { sidebarApi } from '@app/api/Sidebar';
import { socialIntegrationEmailParsingRuleApi } from '@app/api/SocialIntegrationEmailParsingRule';
import { socialIntegrationsApi as socialIntegrationsApi2 } from '@app/api/SocialIntegrations';
import { subscriptionsApi } from '@app/api/Subscriptions';
import { supportApi } from '@app/api/Support';
import { tagsApi as tagsApi2 } from '@app/api/Tags';
import { technologicalMapsApi } from '@app/api/TechnologicalMaps';
import { timezonesApi } from '@app/api/Timezones';
import { userApi } from '@app/api/User';
import { userFileRequestsApi } from '@app/api/UserFileRequests';
import { warehouseInventoriesApi } from '@app/api/WarehouseInventories';
import { warehousesApi2 } from '@app/api/Warehouses';
import { workScheduleApi2 } from '@app/api/WorkSchedule';
import { clientsApi } from '@app/services/rtkQuery/Clients/api';
import { crmTasksApi } from '@app/services/rtkQuery/CrmTasks/api';
import { leadsApi } from '@app/services/rtkQuery/leads';
import { notificationsApi } from '@app/services/rtkQuery/notifications';
import { organizationApi } from '@app/services/rtkQuery/organization';
import { recordsApi } from '@app/services/rtkQuery/Records/api';
import { salesFunnelsApi } from '@app/services/rtkQuery/SalesFunnels/api';
import { salesFunnelsStagesApi } from '@app/services/rtkQuery/SalesFunnelsStages/api';
import { sendoutsApi } from '@app/services/rtkQuery/Sendouts/api';
import { socialIntegrationsApi } from '@app/services/rtkQuery/SocialIntegrations/api';
import { tagsApi } from '@app/services/rtkQuery/Tags/api';
import { warehousesApi } from '@app/services/rtkQuery/Warehouses/api';

import type { Middleware } from '@reduxjs/toolkit';

export const apiSlices = [
  accessRightsApi,
  actionsHistoryApi,
  authenticationApi,
  captchaApi,
  clientPaymentsApi,
  clientsApi,
  crmTasksApi,
  dadataApi,
  dictionariesApi,
  errorReportsApi,
  expenseArticlesApi,
  leadsApi,
  messageTemplatesApi,
  moneyExpensesApi,
  notificationsApi,
  organizationApi,
  recommendChatApi,
  recordsApi,
  salesFunnelsApi,
  salesFunnelsStagesApi,
  robotAttachmentsApi,
  sendoutsApi,
  sendoutsApi2,
  settingsApi,
  sidebarApi,
  socialIntegrationsApi,
  tagsApi,
  timezonesApi,
  userApi,
  warehousesApi,
  employeeSalaryApi,
  warehouseInventoriesApi,
  socialIntegrationEmailParsingRuleApi,
  clientRemindersApi,
  neuralNetworkLogsApi,
  legalEntitiesApi,
  aiOperatorConfigApi,
  aiPromptsApi,
  aiServicesApi,
  technologicalMapsApi,
  externalLoyaltyApi,
  loyaltyApi,
  debugApi,
  billsApi,
  clientsMergeApi,
  // New APIs
  recordsApi2,
  branchesApi2,
  chainsApi,
  analyticsApi2,
  usersApi2,
  employeesApi2,
  workScheduleApi2,
  medicalDocumentsApi,
  warehousesApi2,
  clientApi2,
  clientFilesApi2,
  clientServicesApi2,
  salesFunnelStageLeadApi2,
  leadsApi3,
  salesFunnelsApi2,
  socialIntegrationsApi2,
  integrationAuthApi,
  clientsApi3,
  crmTasksApi2,
  tagsApi2,
  notificationsApi2,
  productsApi,
  clientFieldsApi,
  subscriptionsApi,
  certificatesApi,
  userFileRequestsApi,
  aiBusinessAnalyticsApi,
  salePlansApi,
  migrationApi,
  loggerApi,
  paymentAccountsApi,
  positionsApi2,
  supportApi,
  // Пока только CheckKeywordOverlaps (task/11645). reducerPath 'robotsApi'
  // не занят: легаси-слой роботов живёт в salesFunnelsStagesApi.
  robotsApi,
];

export const middlewares: Middleware[] = apiSlices.map(
  ({ middleware }) => middleware
);

export const reducers = apiSlices.reduce((acc, { reducerPath, reducer }) => {
  acc[reducerPath] = reducer;
  return acc;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}, {} as Record<string, any>);
